import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=58057b2c&scoped=true"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"
import style0 from "./NewItem.vue?vue&type=style&index=0&id=58057b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58057b2c",
  null
  
)

export default component.exports